var map = {
	"./apps/count.svg": 10768,
	"./apps/food.svg": 43067,
	"./apps/material.svg": 3877,
	"./apps/portal.svg": 41700,
	"./apps/repair.svg": 56246,
	"./icons/apps/count.svg": 1406,
	"./icons/apps/food-calc.svg": 79041,
	"./icons/apps/food-control.svg": 55121,
	"./icons/apps/food-report.svg": 40691,
	"./icons/apps/food.svg": 26784,
	"./icons/apps/material.svg": 78661,
	"./icons/apps/repair.svg": 63619,
	"./icons/info.svg": 87314,
	"./icons/logo.svg": 22523,
	"./images/count.jpg": 84225,
	"./images/food.jpg": 19762,
	"./images/material.jpg": 44042,
	"./images/portal.jpg": 63880,
	"./images/repair.jpg": 12756,
	"./styles/style.css": 15034
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5411;